// extracted by mini-css-extract-plugin
export var statItem = "_hm-1";
export var statsRow = "_hm-0";